import apiClient from '@/services/api_client';
import type { CapabilityAudiences } from '@/services/tenant_capabilities';
import { OnboardingStatus } from '@/types';

export type BillingProvider = 'stripe' | 'direct' | 'none';
export type SubscriptionStatus =
    | 'pending_payment'
    | 'active'
    | 'trialing'
    | 'past_due'
    | 'paused'
    | 'incomplete'
    | 'incomplete_expired'
    | 'unpaid'
    | 'canceled';

export type AccessContextResponse = {
    billing_provider: BillingProvider;
    subscription_status: SubscriptionStatus;
    onboarding_status: OnboardingStatus;
    onboarding_current_step: number;
    display_free_trial_banner: boolean;
    trial_days_remaining: number | null;
    display_grace_period_banner: boolean;
    grace_period_days_remaining: number | null;
    can_export_slides: boolean;
    capability_audiences: CapabilityAudiences;
};

export const getAccessContext = async (
    tenantId: string
): Promise<AccessContextResponse> => {
    const url = `/access_context?tenant_id=${encodeURIComponent(tenantId)}`;
    const response = await apiClient.get(url);
    return await response.json();
};
